import { env } from '../../env';

export const isDynatraceEnabled = !!env.CLIENT_DYNATRACE_URL;

export enum AnalyticsProcess {
	ClientDetailProcess = 'ClientDetailProcess',
}

export enum BizEventSource {
	Logger = 'Logger',
}
